var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OCollapse',{class:[
    'ucrs-accordion--noBorderTop ucrs-accordion--noBorderBottom',
    'w-full bg-gray-lightest shadow-inner',
    {
      'lg:mb-8': _vm.show,
    },
  ],attrs:{"animation":"slide","open":_vm.show,"content-class":"max-h-32"}},[_c('div',{staticClass:"container",attrs:{"id":_vm.regionId,"role":"region"}},[_c('p',{staticClass:"h-32 flex items-center justify-around md:justify-between mx-auto max-w-screen-sm"},_vm._l((_vm.services),function(item){return _c('a',{key:item.icon,class:[
          'flex items-center font-bold text-sm uppercase h-full',
          item.class,
        ],attrs:{"rel":"nofollow","target":"_blank","href":item.url,"data-action":item.dataAction}},[_c('SvgIcon',{staticClass:"w-10 md:mr-3 h-full",attrs:{"name":item.icon}}),_vm._v(" "),_c('span',{staticClass:"hidden md:block"},[_vm._v(_vm._s(item.name))])],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }